import React, { useEffect, createElement } from 'react';
import { HomePage } from './pages/HomePage';
export function App() {
  useEffect(() => {
    document.title = 'Motomaniac Hard Enduro Race';
    // Set og:title meta tag
    let ogTitle = document.querySelector('meta[property="og:title"]') as HTMLMetaElement | null;
    if (!ogTitle) {
      ogTitle = document.createElement('meta');
      ogTitle.setAttribute('property', 'og:title');
      document.head.appendChild(ogTitle);
    }
    ogTitle.setAttribute('content', 'Motomaniac Hard Enduro Race');
    // Set og:description meta tag
    let ogDesc = document.querySelector('meta[property="og:description"]') as HTMLMetaElement | null;
    if (!ogDesc) {
      ogDesc = document.createElement('meta');
      ogDesc.setAttribute('property', 'og:description');
      document.head.appendChild(ogDesc);
    }
    ogDesc.setAttribute('content', 'Brutālākās hard enduro sacensības Baltijā. 2026. gada 15.–16. maijs, Pāvuli, Smiltenes novads. Powered by Pirmais Racing.');
    // Set og:image meta tag
    let ogImage = document.querySelector('meta[property="og:image"]') as HTMLMetaElement | null;
    if (!ogImage) {
      ogImage = document.createElement('meta');
      ogImage.setAttribute('property', 'og:image');
      document.head.appendChild(ogImage);
    }
    ogImage.setAttribute('content', 'https://cdn.magicpatterns.com/uploads/bXrefJ2oBh4YLN5nxqUgzp/PHOTO-2024-12-29-00-15-52.jpg');
    // Set og:type meta tag
    let ogType = document.querySelector('meta[property="og:type"]') as HTMLMetaElement | null;
    if (!ogType) {
      ogType = document.createElement('meta');
      ogType.setAttribute('property', 'og:type');
      document.head.appendChild(ogType);
    }
    ogType.setAttribute('content', 'website');
    // Set meta description
    let metaDesc = document.querySelector('meta[name="description"]') as HTMLMetaElement | null;
    if (!metaDesc) {
      metaDesc = document.createElement('meta');
      metaDesc.setAttribute('name', 'description');
      document.head.appendChild(metaDesc);
    }
    metaDesc.setAttribute('content', 'Brutālākās hard enduro sacensības Baltijā. 2026. gada 15.–16. maijs, Pāvuli, Smiltenes novads. Powered by Pirmais Racing.');
  }, []);
  return <HomePage data-id="element-0" />;
}